module.exports = __webpack_public_path__ + "static/media/exclamation-triangle.406b8685.svg";